import { axios, handleError } from '../axios';

export const getPosts = (category, pageNumber, deletedPostCount) => {
  return new Promise((resolve) => {
    axios
      .get('posts/', {
        params: {
          c: category,
          pn: pageNumber,
          s: deletedPostCount,
        },
      })
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
